<template>
  <div :class="classesWrapper" ref="container">
    <div class="autocomplete__input">
      <app-form-input
        v-model="searchText"
        :label="label"
        :placeholder="placeholder"
        :secondary="secondary"
        :borderDashed="borderDashed"
        :borderSolid="borderSolid"
        :boxShadow="boxShadow"
        :round="round"
        @focus="onFocusInput"
        @blur="onBlurInput"
      />
    </div>
    <ul :class="listClasses">
      <li
        v-for="item in itemsList"
        :key="item.id"
        class="autocomplete__list__item"
        v-html="item.text"
        @click="onSelectItem(item.originalItem)"
      ></li>
    </ul>
  </div>
</template>

<script>
import Input from './Input'
import { setTimeout } from 'timers'

const NOT_FOUND = -1
const highlightText = (text, searchText) => {
  const index = text.indexOf(searchText)

  if (!!searchText && index !== NOT_FOUND) {
    return (
      text.substring(0, index) +
      '<strong>' +
      text.substring(index, index + searchText.length) +
      '</strong>' +
      text.substring(index + searchText.length)
    )
  } else {
    return text
  }
}

export default {
  name: 'AppFormAutocomplete',
  status: 'prototype',
  release: '1.0.0',
  inheritAttrs: false,
  components: { Input },
  props: {
    value: {
      required: true
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    secondary: {
      type: Boolean,
      default: false
    },
    borderDashed: {
      type: Boolean,
      default: false
    },
    borderSolid: {
      type: Boolean,
      default: false
    },
    boxShadow: {
      type: Boolean,
      default: false
    },
    round: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: () => []
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemText: {
      type: String,
      default: 'text'
    },
    searchInput: {
      type: String,
      default: 'text'
    }
  },
  data () {
    return {
      searchText: '',
      lazyValue: this.value,
      listIsOpen: false,
      itemsList: []
    }
  },
  computed: {
    classesWrapper () {
      return {
        autocomplete: true
      }
    },
    listClasses () {
      return {
        autocomplete__list: 'autocomplete__list',
        'autocomplete__list--open': !!this.listIsOpen && !!this.itemsList.length
      }
    },
    internalValue: {
      get () {
        return this.lazyValue
      },
      set (val) {
        this.lazyValue = val
        this.$emit('input', val)
      }
    }
  },
  watch: {
    value (val) {
      this.lazyValue = val
    },
    searchText (val) {
      this.$emit('update:search-input', val)

      const searchText = val.toString().toLowerCase()
      this.itemsList = []
      if (!searchText) {
        return
      }

      this.itemsList = this.items
        .filter(item => {
          const text = item[this.itemText].toString().toLowerCase()
          return text.indexOf(searchText) !== NOT_FOUND
        })
        .map(item => {
          const text = item[this.itemText].toString().toLowerCase()
          const textHtml = highlightText(text, searchText)

          return {
            id: item[this.itemValue],
            text: textHtml,
            originalItem: item
          }
        })
    }
  },
  beforeMount () {
    window.addEventListener('click', e => {
      const dropdown = e.target.closest('.autocomplete')
      if (!dropdown || dropdown != this.$refs.container) {
        this.listIsOpen = false
      }
    })
  },
  methods: {
    onFocusInput (e) {
      this.listIsOpen = true
    },
    onBlurInput (e) {
      // this.listIsOpen = false;
    },
    onSelectItem (item) {
      this.searchText = item[this.itemText]
      this.listIsOpen = false
      this.$emit('input', item)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/styles.scss";
.autocomplete {
  position: relative;
  &__input {
    position: relative;
    z-index: 99;
  }
  &__list {
    position: absolute;
    display: none;
    max-height: 250px;
    max-width: 100%;
    left: 20px;
    right: 20px;
    top: 20px;
    padding: 30px 20px 15px 20px;
    z-index: 98;
    border-radius: 6px;
    box-shadow: $shadow-m;
    border: solid 2px $color-purple;
    background: $color-white;
    list-style: none;
    overflow: hidden;
    overflow-y: auto;
    &--open {
      display: block;
    }
    &__item {
      font-family: $font-text;
      font-size: $size-xs;
      padding-bottom: 15px;
      color: $color-purple-darker;
      cursor: pointer;
      &:last-child {
        padding: 0;
      }
      strong {
        font-weight: 600;
      }
    }
  }
}
</style>
